export const FILTERS_CONTEXTS_SEARCH = "FILTERS_CONTEXTS_SEARCH";
export const FILTERS_MUNICIPALITIES_SEARCH = "FILTERS_MUNICIPALITIES_SEARCH";
export const FILTERS_AUDITS = "FILTERS_AUDITS";